import TabItemList from './TabItemList';
import { TabItemListProps, TabItemListValueProps } from './types';

export type { TabItemListProps, TabItemListValueProps };
export default TabItemList;
